import type {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormRequiredLegend,
} from '@/components/ui/form';

import type {WarehouseItemStockUpdateFormValues} from '../utils/warehouseFormInputs';
import SharedStockInput from './SharedStockInput';
import WarehouseInput from './WarehouseInput';
import WarehouseItemInput from './WarehouseItemInput';

export type SharedWarehouseItemStockUpdateFormFieldsProps = {
  form: UseFormReturn<WarehouseItemStockUpdateFormValues>;
};

const SharedWarehouseItemStockUpdateFormFields = ({
  form,
}: SharedWarehouseItemStockUpdateFormFieldsProps) => {
  const {t} = useTranslation();

  return (
    <>
      <FormRequiredLegend />

      <FormField
        control={form.control}
        name="warehouseId"
        render={({field}) => (
          <FormItem>
            <FormLabel required>{t('Warehouse')}</FormLabel>
            <FormControl>
              <WarehouseInput value={field.value} onChange={field.onChange} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="id"
        render={({field}) => (
          <FormItem>
            <FormLabel>{t('Product')}</FormLabel>
            <FormControl>
              <WarehouseItemInput
                inputProps={{
                  disabled: !form.watch('warehouseId'),
                }}
                warehouseId={form.watch('warehouseId')}
                value={field.value}
                onChange={field.onChange}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="amount"
        render={({field}) => (
          <FormItem>
            <FormLabel>{t('Item picked')}</FormLabel>
            <FormControl>
              <SharedStockInput
                {...field}
                warehouseId={form.watch('warehouseId')}
                itemId={form.watch('id')}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default SharedWarehouseItemStockUpdateFormFields;
